package com.wintermar.inspection.feature.presentation.inspection.widget

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.Dp
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.theme.color.model.ThemeColor

@Composable
fun AnswerSummaryContainer(
    clickable: Boolean = true,
    removeClippedCorners: Boolean = false,
    horizontalPadding: Dp = LocalAppTheme.current.dimension.spacing.space2,
    color: ThemeColor = LocalAppTheme.current.color,
    dimension: AppDimension = LocalAppTheme.current.dimension,
    onClick: () -> Unit = {},
    content: @Composable () -> Unit
) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .then(
                if (removeClippedCorners) Modifier
                else Modifier.clip(RoundedCornerShape(dimension.radius.lg))
            )
            .background(
                color = color.surface.neutral.subtle.default
            )
            .clickable(
                enabled = clickable,
                onClick = onClick
            )
            .padding(
                vertical = dimension.spacing.space2,
                horizontal = horizontalPadding
            )
        ,
        verticalArrangement = Arrangement.spacedBy(
            space = dimension.spacing.space2
        )
    ) {
        content()
    }
}
